import React from "react";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";

export const DeleteTicketPopup = (props) => {
  return (
    <Modal show={props.show} onHide={props.onHide} animation={false}>
      <Modal.Header closeButton>
        <Modal.Title>Eine Ebene löschen</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        Sind Sie sicher, dass Sie dieses Ticket löschen möchten?
      </Modal.Body>
      <Modal.Footer>
        <Button variant="primary" onClick={props.onDelete}>
          Bestätigen
        </Button>
        <Button variant="secondary" onClick={props.onHide}>
          Stornierungen{" "}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};
